import api from './api';
import {
  FashionColor,
  FashionPagedResult,
  CurvaTalle,
  Temporada,
  FashionModelo,
  ModeloFoto,
  MatrizModelo,
  GenerarMatrizRequest,
  GenerarMatrizResult,
  CurvaTallesInformeRow,
} from '../types/fashion';

export const colorService = {
  getColores: async (pageNumber = 1, pageSize = 10, searchTerm?: string) => {
    const { data } = await api.get<FashionPagedResult<FashionColor>>('/api/Colores', {
      params: { pageNumber, pageSize, searchTerm },
    });
    return data;
  },
  getColor: async (codigoColor: string) => {
    const { data } = await api.get<FashionColor>(`/api/Colores/${encodeURIComponent(codigoColor)}`);
    return data;
  },
  createColor: async (payload: FashionColor) => {
    const { data } = await api.post<FashionColor>('/api/Colores', payload);
    return data;
  },
  updateColor: async (codigoColor: string, payload: Omit<FashionColor, 'codigoColor'>) => {
    await api.put(`/api/Colores/${encodeURIComponent(codigoColor)}`, payload);
  },
  deleteColor: async (codigoColor: string) => {
    await api.delete(`/api/Colores/${encodeURIComponent(codigoColor)}`);
  },
};

export const curvaTalleService = {
  getCurvas: async (pageNumber = 1, pageSize = 10, searchTerm?: string) => {
    const { data } = await api.get<FashionPagedResult<CurvaTalle>>('/api/CurvasTalle', {
      params: { pageNumber, pageSize, searchTerm },
    });
    return data;
  },
  getCurva: async (codigoCurva: string) => {
    const { data } = await api.get<CurvaTalle>(`/api/CurvasTalle/${encodeURIComponent(codigoCurva)}`);
    return data;
  },
  createCurva: async (payload: CurvaTalle) => {
    const { data } = await api.post<CurvaTalle>('/api/CurvasTalle', payload);
    return data;
  },
  updateCurva: async (codigoCurva: string, payload: Omit<CurvaTalle, 'codigoCurva'>) => {
    await api.put(`/api/CurvasTalle/${encodeURIComponent(codigoCurva)}`, payload);
  },
  deleteCurva: async (codigoCurva: string) => {
    await api.delete(`/api/CurvasTalle/${encodeURIComponent(codigoCurva)}`);
  },
};

export const temporadaService = {
  getTemporadas: async (pageNumber = 1, pageSize = 10, searchTerm?: string) => {
    const { data } = await api.get<FashionPagedResult<Temporada>>('/api/Temporadas', {
      params: { pageNumber, pageSize, searchTerm },
    });
    return data;
  },
  getTemporada: async (codigoTemporada: string) => {
    const { data } = await api.get<Temporada>(`/api/Temporadas/${encodeURIComponent(codigoTemporada)}`);
    return data;
  },
  createTemporada: async (payload: Temporada) => {
    const { data } = await api.post<Temporada>('/api/Temporadas', payload);
    return data;
  },
  updateTemporada: async (codigoTemporada: string, payload: Omit<Temporada, 'codigoTemporada'>) => {
    await api.put(`/api/Temporadas/${encodeURIComponent(codigoTemporada)}`, payload);
  },
  deleteTemporada: async (codigoTemporada: string) => {
    await api.delete(`/api/Temporadas/${encodeURIComponent(codigoTemporada)}`);
  },
};

export const modeloService = {
  getModelos: async (params: {
    pageNumber?: number;
    pageSize?: number;
    searchTerm?: string;
    codigoRamo?: string;
    codigoLinea?: string;
    codigoClase?: string;
    codigoTemporada?: string;
  }) => {
    const { data } = await api.get<FashionPagedResult<FashionModelo>>('/api/Modelos', { params });
    return data;
  },
  getModelo: async (codigoModelo: string) => {
    const { data } = await api.get<FashionModelo>(`/api/Modelos/${encodeURIComponent(codigoModelo)}`);
    return data;
  },
  createModelo: async (payload: Omit<FashionModelo, 'cantidadVariantes' | 'nombreCurva' | 'nombreTemporada'>) => {
    const { data } = await api.post<FashionModelo>('/api/Modelos', payload);
    return data;
  },
  updateModelo: async (
    codigoModelo: string,
    payload: Omit<FashionModelo, 'codigoModelo' | 'cantidadVariantes' | 'nombreCurva' | 'nombreTemporada'>,
  ) => {
    await api.put(`/api/Modelos/${encodeURIComponent(codigoModelo)}`, payload);
  },
  deleteModelo: async (codigoModelo: string) => {
    await api.delete(`/api/Modelos/${encodeURIComponent(codigoModelo)}`);
  },
  getMatriz: async (codigoModelo: string, nroUbicacion?: number) => {
    const { data } = await api.get<MatrizModelo>(
      `/api/Modelos/${encodeURIComponent(codigoModelo)}/matriz`,
      { params: { nroUbicacion } },
    );
    return data;
  },
  generarMatriz: async (codigoModelo: string, payload: GenerarMatrizRequest) => {
    const { data } = await api.post<GenerarMatrizResult>(
      `/api/Modelos/${encodeURIComponent(codigoModelo)}/matriz/generar`,
      payload,
    );
    return data;
  },
  getFotos: async (codigoModelo: string, codigoColor?: string) => {
    const { data } = await api.get<ModeloFoto[]>(
      `/api/Modelos/${encodeURIComponent(codigoModelo)}/fotos`,
      { params: codigoColor ? { codigoColor } : undefined },
    );
    return data;
  },
  uploadFoto: async (
    codigoModelo: string,
    input: { archivo: File; codigoColor: string; esPrincipal?: boolean },
  ) => {
    const formData = new FormData();
    formData.append('archivo', input.archivo);
    formData.append('codigoColor', input.codigoColor);
    if (input.esPrincipal != null) {
      formData.append('esPrincipal', String(input.esPrincipal));
    }
    const { data } = await api.post<ModeloFoto>(
      `/api/Modelos/${encodeURIComponent(codigoModelo)}/fotos`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },
  setFotoPrincipal: async (codigoModelo: string, fotoId: number) => {
    await api.put(`/api/Modelos/${encodeURIComponent(codigoModelo)}/fotos/${fotoId}/principal`);
  },
  deleteFoto: async (codigoModelo: string, fotoId: number) => {
    await api.delete(`/api/Modelos/${encodeURIComponent(codigoModelo)}/fotos/${fotoId}`);
  },
};

export const fashionInformesService = {
  getCurvaTalles: async (params?: {
    codigoModelo?: string;
    codigoTemporada?: string;
    codigoColor?: string;
    soloQuiebre?: boolean;
  }) => {
    const { data } = await api.get<{ data: CurvaTallesInformeRow[]; totalCount: number }>(
      '/api/InventarioInformes/curva-talles',
      { params },
    );
    return data;
  },
};
